// extracted by mini-css-extract-plugin
export default {"FullScreenButton":"FullScreenButton_FullScreenButton__4gtKQ","smoothAppear":"FullScreenButton_smoothAppear__KtjTa"};